import React from 'react'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined'

export const BackBtn = ({ handleSwitch, additionalClass }) => {
    return (
        <span onClick={handleSwitch} className={`cursor_pointer ${additionalClass}`}>
            <ArrowBackOutlinedIcon color="action" fontSize="small" />
        </span>
    )
}